/* eslint-disable no-use-before-define */

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { up, down } from 'slide-element';
import clickOutside from 'click-outside';
import { createFocusTrap } from 'focus-trap';
import announcer from './aria-announcer';

let unbindClickOutside;
let focusTrap;

const $body = document.querySelector('body');
const $menuItems = document.querySelectorAll('.has-submenu');
const $navBtns = document.querySelectorAll('.nav-primary-element');

// Close submenu on escape key
function onEscape(event) {
    if (event.key === 'Escape') {
        $menuItems.forEach((item) => {
            const $button = item.querySelector('button');
            if ($button.getAttribute('aria-expanded') === 'true') {
                collapseSubMenu(item);
                window.removeEventListener('keydown', onEscape);
            }
        });
    }
}

const expandSubMenu = (item) => {
    const $subMenu = item.querySelector('.mega-menu-wrapper');
    const $button = item.querySelector('button');

    $subMenu.setAttribute('aria-hidden', 'false');
    $button.setAttribute('aria-expanded', 'true');

    disableBodyScroll($subMenu);
    down($subMenu);

    // Close all other submenus
    $menuItems.forEach((menuItem) => {
        if (menuItem !== item) {
            collapseSubMenu(menuItem);
        }
    });

    // Add overlay
    $body.classList.add('locked');

    // clickOutside
    unbindClickOutside = clickOutside($subMenu, () => {
        collapseSubMenu(item);
    });

    setTimeout(() => {
        // Initialize and activate focus trap
        focusTrap = createFocusTrap($subMenu, {
            clickOutsideDeactivates: true,
            preventScroll: true,
        });
        focusTrap.activate();
    }, 100);

    // Aria live
    announcer.announce(`Le menu ${$button.textContent} est ouvert`);

    window.addEventListener('keydown', onEscape);
};

const collapseSubMenu = (item) => {
    const $subMenu = item.querySelector('.mega-menu-wrapper');
    const $button = item.querySelector('button');

    $subMenu.setAttribute('aria-hidden', 'true');
    $button.setAttribute('aria-expanded', 'false');

    up($subMenu);

    // Check through all the $navBtns if any have aria-expanded="true"
    const anyExpanded = Array.from($navBtns).some((btn) => btn.getAttribute('aria-expanded') === 'true');

    if (!anyExpanded) {
        enableBodyScroll($subMenu);
        focusTrap.deactivate();
    }

    // Remove overlay
    $body.classList.remove('locked');

    // clickOutside
    if (unbindClickOutside) {
        unbindClickOutside();
        unbindClickOutside = null;
    }

    // Aria live
    announcer.announce(`Le menu ${$button.textContent} est fermé`);

    // Remove addEventListener on escape key
    window.removeEventListener('keydown', onEscape);
};

$menuItems.forEach((item) => {
    const $button = item.querySelector('button');

    $button?.addEventListener('click', (event) => {
        event.stopPropagation();
        if ($button.ariaExpanded === 'false') {
            expandSubMenu(item);
        } else {
            collapseSubMenu(item);
        }
    });
});
